import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 16 4",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  d: "M2.16667 0.333008C1.72464 0.333008 1.30072 0.508603 0.988156 0.821163C0.675595 1.13372 0.5 1.55765 0.5 1.99967C0.5 2.4417 0.675595 2.86563 0.988156 3.17819C1.30072 3.49075 1.72464 3.66634 2.16667 3.66634C2.60869 3.66634 3.03262 3.49075 3.34518 3.17819C3.65774 2.86563 3.83333 2.4417 3.83333 1.99967C3.83333 1.55765 3.65774 1.13372 3.34518 0.821163C3.03262 0.508603 2.60869 0.333008 2.16667 0.333008Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("path", {
  d: "M8 0.333008C7.55797 0.333008 7.13405 0.508603 6.82149 0.821163C6.50893 1.13372 6.33333 1.55765 6.33333 1.99967C6.33333 2.4417 6.50893 2.86563 6.82149 3.17819C7.13405 3.49075 7.55797 3.66634 8 3.66634C8.44203 3.66634 8.86595 3.49075 9.17851 3.17819C9.49107 2.86563 9.66667 2.4417 9.66667 1.99967C9.66667 1.55765 9.49107 1.13372 9.17851 0.821163C8.86595 0.508603 8.44203 0.333008 8 0.333008Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("path", {
  d: "M13.8333 0.333008C13.3913 0.333008 12.9674 0.508603 12.6548 0.821163C12.3423 1.13372 12.1667 1.55765 12.1667 1.99967C12.1667 2.4417 12.3423 2.86562 12.6548 3.17819C12.9674 3.49075 13.3913 3.66634 13.8333 3.66634C14.2754 3.66634 14.6993 3.49075 15.0118 3.17819C15.3244 2.86562 15.5 2.4417 15.5 1.99967C15.5 1.55765 15.3244 1.13372 15.0118 0.821163C14.6993 0.508603 14.2754 0.333008 13.8333 0.333008Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4
  ]))
}